const Symbol = ({ text }) => {
  return (
    <div className="para">
      <span>&#42;</span>
      <span> {text}</span>
    </div>
  );
};

export default Symbol;
